export default __webpack_public_path__ + "static/media/coronation.59aec513.webp";